<template>
    <div id="content">
        <loader></loader>
        <div class="top">
            <div class="header">
                <h1>Ajout d'un appel</h1>
                <div class="pageOptions">
                    <Btn text="Enregistrer" ico="valide" @click="confirmSave"
                         v-if="($store.getters.hasPerm('call:add') && is('add')) || ($store.getters.hasPerm('call:edit') && is('edit')) || ($store.getters.hasPerm('call:edit:limit') && editLimit() && is('edit'))"></Btn>
                    <Btn ico="times" color="red" @click="cancel"
                         v-if="($store.getters.hasPerm('call:add') && is('add')) || ($store.getters.hasPerm('call:edit') && is('edit')) || ($store.getters.hasPerm('call:edit:limit') && editLimit() && is('edit'))"></Btn>
                    <Btn text="Fermer" @click="$router.back()"
                         v-if="($store.getters.hasPerm('call:show') && is('show'))"></Btn>
                </div>
            </div>
        </div>
        <form class="" action="" method="post" autocomplete="off">
            <input autocomplete="off" name="hidden" type="text" style="display:none;"/>
            <div class="superLine">
                <div class="line">
                    <div class="little">
                        <label for="date">Date</label>
                        <input type="date" id="date" v-model="data.date_start" readonly="1">
                    </div>
                    <div class="little">
                        <label for="dateValidation">Date de validation</label>
                        <input type="date" v-model="data.date_validation" id="dateValidation" readonly="1">
                    </div>
                </div>
                <div class="line">
                    <div class="little">
                        <label for="heureDebut">Heure de debut</label>
                        <input type="time" class="time" v-model="data.hour_start" id="heureDebut" readonly="1">
                    </div>
                    <div class="little">
                        <label for="heureValidation">Heure de validation</label>
                        <input type="time" class="time" v-model="data.hour_validation" id="heureValidation"
                               readonly="1" :readonly="is('show')">
                    </div>
                </div>
            </div>
            <div class="line">
                <div class="large">
                    <label>Nom du client</label>
                    <model-list-select v-model="customer"
                                       :list="customers"
                                       option-value="id"
                                       option-text="company"
                                       placeholder="Sélectionner un client"
                                       :isDisabled="select.customers.disabled || is('show')">

                    </model-list-select>
                </div>
                <btn text="Informations" @click="informations" ico="survey" v-if="customer.informations"></btn>
            </div>
            <div class="line">
                <div class="large">
                    <label>Motif de l'appel</label>
                    <model-list-select v-model="data.reason"
                                       :list="reasons"
                                       option-value="id"
                                       option-text="label"
                                       placeholder="Sélectionner un motif d'appel"
                                       class="mb"
                                       :isDisabled="select.reasons.disable || is('show')" @input="selectReason">

                    </model-list-select>
                    <span v-if="questionnaireSkipped">
                        <i style="color:#8a0000">Le questionnaire n'a pas été renseigné volontairement</i>
                        <i style="color:#8a0000" v-if="response_id > 0"> (a été répondu plus tard)</i>
                    </span>
                </div>
                
                <btn :text="!response_id || response_id <= 0 ?'Questionnaire':'Réponses'" @click="questionnaire"
                     ico="survey" v-if="questionnaireId"></btn>
            </div>
            <div class="line">
                <div class="medium">
                    <label for="callName">Nom du patient <span style="color:red">*</span></label>
                    <input type="text" v-model="data.call_name" id="callName" :readonly="is('show')">
                </div>
                <div class="medium">
                    <label for="telephone">N° de téléphone</label>
                    <input type="tel" v-model="data.phone_number" id="telephone" :readonly="is('show')">
                </div>
                <div class="small">
                    <label for="birthday">Date de naissance</label>
                    <input type="date" v-model="data.call_birthday" id="birthday" :readonly="is('show')">
                </div>
                <div class="small" v-if="age !== ''">
                    <div class="btn blue" style="cursor:default;box-shadow: 0px 8px 10px rgb(0, 128, 255, 0.3);">
                        {{age}}
                    </div>
                </div>
            </div>
            <div class="line">
                <div class="large">
                    <label for="callMeet">Nombre de RDV durant l'appel <span v-if="callMeetRequire"
                                                                             style="color:red">*</span></label>
                    <input type="text" v-model="data.call_meet" id="callMeet" :readonly="is('show')">
                </div>
            </div>
            <div class="line">
                <div class="large">
                    <label for="observation">Observation <span v-if="observationRequire"
                                                               style="color:red">*</span></label>
                    <textarea v-model="data.observation" rows="4" id="observation" :readonly="is('show')"></textarea>
                </div>
            </div>
            <div class="large mb">
                Secrétaire
                <model-list-select v-model="data.user"
                                   :list="users"
                                   option-value="id"
                                   :custom-text="userName"
                                   placeholder="Sélectionner un utilisateur"
                                   :isDisabled="select.users.disable">
                </model-list-select>
            </div>
            <p class="">
                <span style="color:red">*</span> : champ obligatoires
            </p>
        </form>
    </div>
</template>

<script>
    import Btn from "@/components/Btn";
    import axios from 'axios';
    import tools from '../config.ts';
    import moment from 'moment';
    import {ModelListSelect} from 'vue-search-select';
    import Loader from "@/components/Loader";

    export default {
        name: "Call",
        components: {Btn, ModelListSelect, Loader},
        data() {
            return {
                callId: 0,

                customers: [],
                reasons: [],
                users: [],
                questionnaireId: 0,

                customer: {},

                data: {},
                response_id: 0,
                action: 'show',
                dataDefault: {
                    user: {},
                    date_start: moment().format("YYYY-MM-DD"),
                    hour_start: moment().format("HH:mm:ss"),
                },

                reasonReset: true,

                select: {
                    customers: {
                        load: false,
                        disabled: false,
                    },
                    reasons: {
                        load: false,
                        disable: true,
                    },
                    users: {
                        load: false,
                        disable: false,
                    }
                },

                observationRequire: false,
                callMeetRequire: false,
                questionnaireSkipped: false,

                locals: ["customers", "reasons", "data", "users", "customer", "callId"],
            }
        },
        methods: {
            userName(user) {
                if (user.firstname && user.lastname) {
                    return `${user.firstname} ${user.lastname}`;
                }

                return `${user.login}`;
            },

            load() {

                // load all data for the current Id
                if (this.callId) {
                    axios.get(tools.api("call/" + this.callId), tools.headerGET())
                        .then(response => {
                            if (response.data) {
                                this.data = response.data;

                                this.response_id = this.data.response_id;

                                this.customer = this.data.customer;

                                this.questionnaireSkipped = this.data.questionnaire_skipped === "1";

                                this.selectReason(this.data.reason.id);

                                console.log(this.response_id)

                            }
                        })
                } else {

                    this.data = this.dataDefault;
                    this.data.user.id = this.$store.getters.getUser.id;

                    if (this.$store.getters.getCurrentResponseId > 0) {
                        this.response_id = this.$store.getters.getCurrentResponseId;
                    }

                    console.log(this.response_id)

                    tools.loader(false);
                }
            },
            save() {

                let url = "call";
                if (this.callId) {
                    url += "/" + this.callId;
                }

                if (!this.data.reason) {
                    return tools.popup("valid", {
                        title: "Erreur",
                        message: "Vous devenez reseigner un motif d'appel"
                    })
                }

                if (!this.data.reason.id) {
                    this.data.reason = this.reasons.filter(reason => reason.id === this.data.reason)[0]
                }

                if (!this.data.call_name) {
                    return tools.popup("valid", {
                        title: "Erreur",
                        message: "Vous devez renseigner le nom du client"
                    })
                }

                if (!this.customer) {
                    return tools.popup("valid", {
                        title: "Erreur",
                        message: "Vous devenez reseigner un client"
                    })
                }
                if (!this.data.reason) {
                    return tools.popup("valid", {
                        title: "Erreur",
                        message: "Vous devenez reseigner un motif d'appel"
                    })
                }
                if (this.data.reason.call_meet_require === "1" && !this.data.call_meet) {

                    return tools.popup("valid", {
                        title: "Erreur",
                        message: "Le nombre de rdv durant l'appel est obligatoire pour ce motif d'appel"
                    })
                }
                if (this.data.reason.observation_require === "1" && !this.data.observation) {

                    return tools.popup("valid", {
                        title: "Erreur",
                        message: "Une observation est obligatoire pour ce motif d'appel"
                    })
                }

                let form = {
                    user_id: this.data.user.id,
                    customer_id: this.customer.id,
                    reason_id: this.data.reason.id,
                    response_id: this.response_id,
                    date_start: this.data.date_start,
                    date_validation: this.data.date_validation,
                    hour_start: this.data.hour_start,
                    hour_validation: this.data.hour_validation,
                    phone_number: this.data.phone_number,
                    observation: this.data.observation,
                    call_meet: this.data.call_meet,
                    call_name: this.data.call_name,
                    call_birthday: this.data.call_birthday,
                    questionnaire_skipped: this.data.questionnaire_skipped,
                }

                tools.loader(true);

                axios.post(tools.api(url), tools.toPOST(form), tools.headerPOST())
                    .then((response) => {
                        tools.loader(false);
                        if (!tools.isSuccessResponse(response)) {
                            return tools.popup("valid", {
                                title: "Erreur",
                                message: "Erreur lors de l'enregistrement de l'appel.",
                            });
                        }
                        tools.removeLocal("call");
                        this.$store.commit("setResponseId", 0);
                        this.$router.push("/calls")
                    })
                    .catch((error) => {
                        tools.loader(false);
                        tools.popup("valid", {
                            title: "Erreur",
                            message: "Erreur lors de l'enregistrement de l'appel. <br/><br/>Détail de l'erreur : <br/>" + tools.parseError(error)
                        })
                    })
            },
            cancel() {
                tools.popup("confirm", {
                    title: "Confirmer",
                    message: "Voulez-vous vraiment annuler les modifications ?",
                    success: () => {
                        tools.removeLocal("call");
                        this.$store.commit("setResponseId", 0);
                        this.$router.push("/calls")
                    }
                })
            },
            editLimit() {
                if (!this.data) {
                    return false;
                }
                return tools.editLimit(this.data);
            },
            questionnaire() {

                tools.saveLocals("call", this);

                let url = "/customer/" + this.customer.id + "/questionnaire/" + this.questionnaireId + "/response";

                if (this.response_id > 0) {
                    url = "/customer/" + this.customer.id + "/questionnaire/" + this.data.response.questionnaire_id + "/response/" + this.response_id
                }

                this.$router.push(url)
            },
            selectReason(reasonId) {

                let reason = this.data.reason;
                if (!reason.id) {
                    reason = this.reasons.filter(reason => reason.id === this.data.reason)[0]
                }

                this.observationRequire = reason.observation_require === "1";
                this.callMeetRequire = reason.call_meet_require === "1";

                axios.get(tools.api("customer/" + this.customer.id + "/reason/" + reasonId), tools.headerGET())
                    .then((response) => {
                        let data = response.data;

                        this.questionnaireId = 0;

                        tools.loader(false);
                        if (!data || data.length <= 0) {
                            return;
                        }

                        this.questionnaireId = data[0].id

                    })
                    .catch(() => {
                        tools.loader(false);
                    })
            },
            is(is) {
                return this.action === is;
            },
            confirmSave() {

                if (!this.data.questionnaire_skipped) {
                    this.data.questionnaire_skipped = 0;
                    if (!this.response_id && this.questionnaireId && !this.$store.getters.hasPerm('call:questionnaire:skip')) {
                        return tools.popup("confirm", {
                            title: "Confirmer",
                            message: "Est vous certain(e) de vouloir enregistrer l'appel sans avoir renseigné de questionnaire ?",
                            success: () => {
                                this.data.questionnaire_skipped = 1;
                                this.save();
                            }
                        })
                    }
                }

                if (!this.customer || !this.customer.company) {
                    return this.save();
                }

                tools.popup("confirm", {
                    title: "Confirmer",
                    message: "Confirmez-vous que l'appel correspond bien au client : <b>" + this.customer.company + "</b>",
                    success: () => {
                        this.save();
                    }
                })
            },
            informations() {
                if (this.customer.informations) {
                    tools.popup("valid", {
                        title: "Informations",
                        message: this.customer.informations
                    })
                }
            }
        },
        watch: {

            customer() {
                if (!this.customer) {
                    return;
                }

                this.select.reasons.disable = true;
                this.questionnaireId = 0;

                // console.log(this.reasonReset);

                if (this.data.reason && this.is("add") && this.reasonReset) {
                    this.data.reason = -1;
                }

                // Load reasons of customer
                axios.get(tools.api("reasons/customer/" + this.customer.id), tools.headerGET())
                    .then(response => {
                        this.reasons = response.data;

                        this.select.reasons.load = false;
                        this.select.reasons.disable = false;
                    })

                if (this.customer.observation) {
                    tools.popup("valid", {
                        title: "Observations",
                        message: this.customer.observation
                    })
                }
            },
            $route() {
                this.callId = this.$route.params.id;
                this.load()
            }
        },
        computed: {
            age(){
                let date = moment(this.data.call_birthday)
                console.log(date)
                console.log(moment())
                if(!date.isValid() || moment().format("YYYY-MM-DD") === date.format("YYYY-MM-DD"))
                    return "";
            
                let age = parseInt(moment().diff(date, 'years'));
            
                if(age > 200 || age < 0) return "";
            
                return age+" ans"
            
            }
        },
        mounted() {

            this.action = this.$route.params.action;

            if (!this.$store.getters.hasPerm("call:add") && this.is('add') ||
                (!this.$store.getters.hasPerm("call:edit") && !this.$store.getters.hasPerm("call:edit:limit")) && this.is('edit') ||
                !this.$store.getters.hasPerm("call:show") && this.is('show')) {
                return this.$router.back();
            }

            tools.loader(true);
            this.$store.commit("onEditMode", true);

            this.select.users.disable = !this.$store.getters.hasPerm("call:add/edit:user");

            this.callId = this.$route.params.id;

            // load all users
            this.select.users.load = true;
            axios.get(tools.api("users"), tools.headerGET())
                .then(response => {
                    this.users = response.data;
                    this.select.users.load = false;
                });

            //load all customers for select
            this.select.customers.load = true;
            axios.get(tools.api("customers"), tools.headerGET())
                .then(response => {
                    this.customers = response.data;
                    this.select.customers.load = false;

                    if (this.customers.length <= 0) {
                        this.customers.push({
                            id: 0,
                            company: "Il n'y a aucun client"
                        })
                    }
                });

            this.load();
            //
            // if(this.$store.getters.getCurrentResponseId > 0){
            //     this.data.response_id = this.$store.getters.getCurrentResponseId;
            // }

            if (tools.setLocals("call", this)) {
                this.reasonReset = false
            }

            if (this.data.reason && !this.data.reason.id) {
                this.selectReason(this.data.reason)
            } else if (this.data.reason && this.data.reason.id) {
                this.selectReason(this.data.reason.id)
            }

        }
    }
</script>